var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { LazyEmitter } from './RenderThread';
import { ConsultCookieName } from '../const';
import { getConsultCookie } from '../utils';
/**
 * 挽留弹窗抽象类
 */
var MobileModel = /** @class */ (function (_super) {
    __extends(MobileModel, _super);
    function MobileModel() {
        var _this = _super.call(this) || this;
        _this.autoPhoneEnabled = false;
        _this.expirationTime = 60 * 60 * 24 * 10;
        _this.mobile = getConsultCookie(ConsultCookieName.Mobile);
        _this.carrierType = Number(getConsultCookie(ConsultCookieName.Carrier_Type, 0));
        _this.encryptPhone = getConsultCookie(ConsultCookieName.Encrypt_Phone);
        return _this;
    }
    MobileModel.prototype.isValidPhoneNumber = function () {
        return !!(this.mobile || this.encryptPhone);
    };
    MobileModel.prototype.onUpdate = function () {
        this.emitRenderEvent('onUpdate');
    };
    return MobileModel;
}(LazyEmitter));
export { MobileModel };
